var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83333 0.665496V2.8035V0.665496ZM7.08333 2.8035V0.850963L1.29198 5.99883L7.084 11.1473V9.39083V8.52948L7.93716 8.64796C9.59632 8.87836 13.587 9.95999 15.7452 14.9044C15.649 10.6079 14.1062 7.92609 12.3926 6.24614C10.6022 4.49082 8.57108 3.77797 7.63898 3.52788L7.08333 3.37879V2.8035ZM7.16744 11.3322L7.16775 11.3302L7.16744 11.3322Z",
    stroke: "#007AFF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.5c241cb88f2ce8f53511ac73870e32d1.svg";
export { ForwardRef as ReactComponent };